import { useCallback } from 'react';
import type { SwitchContainerProps, SwitchOwnProps } from './switch';

export const useSwitch = (props: SwitchOwnProps): SwitchContainerProps => {
  const { onChange, onBlur } = props;

  const handleChange = useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      // This is to ensure blur fires after change to correctly set dirty fields in the state
      onChange(checked);
      onBlur();
    },
    [onBlur, onChange]
  );

  return { handleChange };
};
